import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, TextField } from '@mui/material';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import config from '../../../config/config';
import classes from './AddCreditForm.module.css';

const { creditFormPrefix } = config;

export const AddCreditForm = () => {
	const [dept, setDept] = useState({
		name: '',
	});
	const axiosPrivate = useAxiosPrivate();
	const [message, setMessage] = useState('');

	const navigate = useNavigate();

	async function createDeptForm(event) {
		try {
			event.preventDefault();
			setMessage('');
			const form = new FormData(event.currentTarget);
			const f_data = Object.fromEntries(form.entries());
			const response = await axiosPrivate.post(`${creditFormPrefix}`, f_data);
			navigate(-1);
		} catch (error) {
			setMessage(error?.response?.data?.message);
			console.error(error?.response?.data?.message);
		}
	}

	const handleChange = (e) => {
		setDept((prev) => ({ ...prev, [e.target.name]: e.target.value }));
	};

	return (
		<>
			<div className={classes.newUser}>
				<h1 className={classes.newUserTitle}>Новая форма долга</h1>
				<form className={classes.newUserForm} onSubmit={createDeptForm}>
					<TextField
						type="text"
						placeholder="Введите название"
						label="Название"
						name="name"
						onChange={handleChange}
						required
						value={dept.name}
					/>
					<Button variant="contained" type="submit">
						Создать
					</Button>
				</form>
				<div className={classes.newUserErrorMessage}>{message}</div>
			</div>
		</>
	);
};
